import throttle from 'lodash/throttle';
import debounce from 'lodash/debounce';

const altHeaderScroll = () => {
	const headerWrapper = document.querySelector('.header-wrapper');

	if (!headerWrapper || headerWrapper.dataset.altHeader !== 'true') {
		return;
	}

	let isTransitioning = false;
	const threshold = 1; // Minimum scroll distance before changing state

	const handleScroll = throttle(() => {
		if (isTransitioning) return;

		const scrollTop =
			window.pageYOffset || document.documentElement.scrollTop;

		// Only at very top - show alt-style
		if (scrollTop <= 10) {
			if (!headerWrapper.classList.contains('alt-style')) {
				isTransitioning = true;
				headerWrapper.classList.add('alt-style');
				setTimeout(() => {
					isTransitioning = false;
				}, 300);
			}
		}
		// Scrolled down past threshold - remove alt-style
		else if (
			scrollTop > threshold &&
			headerWrapper.classList.contains('alt-style')
		) {
			isTransitioning = true;
			headerWrapper.classList.remove('alt-style');
			setTimeout(() => {
				isTransitioning = false;
			}, 300);
		}
	}, 16);

	// Debounced check for when scrolling stops
	const checkScrollEnd = debounce(() => {
		const scrollTop =
			window.pageYOffset || document.documentElement.scrollTop;

		if (scrollTop <= 10 && !headerWrapper.classList.contains('alt-style')) {
			headerWrapper.classList.add('alt-style');
		}
	}, 150);

	window.addEventListener(
		'scroll',
		() => {
			handleScroll();
			checkScrollEnd();
		},
		{ passive: true }
	);

	// Initial check
	handleScroll();
};

export default altHeaderScroll;
